import {AppDateFormat, DebugOn} from "./CommonConfig";
import {checkNullStr, formatDate} from "./fusion-ui/utils/ReactUtils";
import {DefStrNA, DefStrNAPlain} from "./fusion-ui/config/FusionConfig";

export function formatDateValue(dateValue, dateFormat = AppDateFormat, defValue = DefStrNA) {
    let date = (checkNullStr(dateValue) && (dateValue != DefStrNA && dateValue != DefStrNAPlain)) ? formatDate(dateValue, dateFormat) : defValue;
    return (date == '1970-01-01') ? defValue : date;
}

export function printLog(...logs) {
    if (DebugOn) console.log(...logs);
}

export function printError(...logs) {
    if (DebugOn) console.error(...logs);
}

export function printWarn(...logs) {
    if (DebugOn) console.warn(...logs);
}

export function printInfo(...logs) {
    if (DebugOn) console.info(...logs);
}

export function printDebug(...logs) {
    if (DebugOn) console.debug(...logs);
}
